import {Modal} from "react-bootstrap";

import {
  CheckSnippet,
  CheckSnippetProps,
  CheckSnippetTitle,
} from "@/pages/checks/components/form/snippets/CheckSnippet.tsx";

interface CheckSnippetModalProps extends Omit<CheckSnippetProps, "onModal"> {
  show: boolean;
  onClose: () => void;
}

export const CheckSnippetModal = ({show, onClose, ...props}: CheckSnippetModalProps) => {
  return (
    <Modal show={show} centered onHide={onClose}>
      <Modal.Header closeButton>
        <div className="pulseTextH2Bold">{CheckSnippetTitle[props.serviceType]}</div>
      </Modal.Header>
      <Modal.Body>
        <CheckSnippet {...props} onModal />
      </Modal.Body>
    </Modal>
  );
};
